import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'reducers';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { 
	ArrowLeft2, 
	ProfileIcon,
	LockIcon,
	LogoutIcon,
	LogoutGray,
	UserSettings,
	MenuIcon,
	UserIcon,
	CaretIcon,
	CompanyIcon
} from 'assets/icons';
import { Logo, WhiteImage } from 'assets/img';

interface Props {
	className?: string;
	toggleSidebar?: any;
	toggleResponsive?: any;
}

const logout = (dispatch: any,history: any) => {
	Globals.confirm('¿Desea cerrar sesión?',() => {
		dispatch({
			type: 'SET_USER',
			payload: null
		});
		dispatch({
			type: 'SET_ACCESS_TOKEN',
			payload: null
		});
		history.replace('/login');
		Globals.quitLoading();
	});
}

const Header = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);
	const user = useSelector((state: RootState) => state.user);
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();

	return (
		<div id="header" className={ props.className }>
			<div className="container-blue-top">
				<button className="navbar-toggler responsive" type="button" onClick={ () => {
					props.toggleResponsive();
				} }>
				    <img src={ MenuIcon } />
				</button>
				<div className="container-buttons-top">
					<div className="container-buttons-web buttons-left">
						{
							user && (
								<div className="container-user" onClick={ () => history.replace(user?.level_id != Constants.LEVELS.ADMIN ? '/client/agent' : '/') }>
									<div>
										<div className="container-image">
											<img src={ CompanyIcon } />
										</div>
									</div>
									<div style={{ width: '85%' }}>
										<h6>{ user?.level_id != Constants.LEVELS.ADMIN ? 'Empresa' : 'Administrador' }</h6>
										{
											user?.level_id != Constants.LEVELS.ADMIN && (
												<p>{ user?.person?.company_name || 'Por configurar' }</p>
											)
										}
									</div>
								</div>
							)
						}
					</div>
					<div className="container-buttons-web">
						{
							user && (
								<>
									<div className="container-user" onClick={ () => history.replace('/profile') }>
										<div>
											<div className="container-image">
												<img src={ UserIcon } />
											</div>
										</div>
										<p>Mi Cuenta</p>
									</div>
									<a href="#" onClick={ (e: any) => {
										e.preventDefault();
										logout(dispatch,history);
									} }>
										<img src={ LogoutIcon } />
									</a>
								</>
							)
						}
					</div>
				</div>
			</div>		
		</div>
	)	
}

export default Header;